import { Grid, MenuItem, Tooltip, Typography } from '@material-ui/core';
import { CheckCircle, Edit, Error, HighlightOff, Delete, Brush, GetApp } from '@material-ui/icons';
import { emissaoStatusDescriptions, registroStatusDescriptions, tipoLiquidacaoDescriptions } from 'common/genericDescriptions';
import { useGenericStyles } from 'common/genericStyles';
import { obterStatusExibido, podeExibirEditar, possuiProcessoEmAndamento } from './editarInstrumentoRegras';
import {
  InstrumentoFinanceiroApiResponse,
  EmissaoStatus,
  SolicitarLiquidacaoRequest,
  GrupoAcesso,
  RegistroStatus,
  InstrumentoFinanceiro,
  Perfil,
  FuncaoParticipante,
  TipoRegistroInstrumentoFinanceiro,
  TipoLiquidacao,
  InstrumentosFinanceirosFilter,
  Custodiante,
  GETInstrumentosFilterParams,
} from 'common/genericTypes';
import Chip from 'components/chip';
import { GenericDrawer } from 'components/genericDrawer';
import { GenericToast, GenericToastKind } from 'components/genericToast';
import { JustificativaAnexoDrawer } from 'components/justificativaAnexoDrawer';
import MoreOptionsMenu from 'components/moreOptionsMenu';
import DownloadIcon from '@material-ui/icons/GetApp';
import { Description } from '@material-ui/icons';
import { Attachment } from 'components/uploadDocs';
import { Dropdown, MdSpace, NumberField, SmSpace, TextButton, TextField } from 'm2m.components';
import { ArrowRightCircle } from 'mdi-material-ui';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'store/index';
import { addAlert } from 'store/modules/snackBar';
import { labelsCaracteristicas } from 'pages/cra/registro/labels';
import {
  DataGridPro,
  GridCellParams,
  GridColDef,
  GridFilterModel,
  GridLocaleText,
  GridSortModel,
  GridValueGetterParams,
  getGridDateOperators,
  getGridSingleSelectOperators,
  getGridStringOperators,
} from '@mui/x-data-grid-pro';
import { componentsPropsValues, rowsPerPageOptionsValues } from 'utils/dataGrid/dataGridUtils';
import CustomToolBarUtils from 'utils/dataGrid/customToolBar';
import { formatDate } from 'utils/date';
import { formatEightDecimalsNumber } from 'utils/number';

enum DrawerAction {
  Suspender,
  Liberar,
}

export const localizedTextsMap = {
  toolbarExport: 'Exportar',
  toolbarExportCSV: 'Exportar em CSV',
  toolbarExportPrint: 'Imprimir',
  columnMenuUnsort: 'Não classificado',
  columnMenuSortAsc: 'Ordem crescente',
  columnMenuSortDesc: 'Ordem decrescente',
  columnMenuFilter: 'Filtro',
  columnMenuHideColumn: 'Ocultar',
  columnMenuShowColumns: 'Mostrar colunas',
  columnsPanelHideAllButton: 'Ocultar todos',
  columnsPanelShowAllButton: 'Exibir todos',
  columnsPanelTextFieldLabel: 'Pesquisar coluna',
  columnsPanelTextFieldPlaceholder: 'Nome da coluna',
  columnHeaderSortIconLabel: 'Ordernar',
  MuiTablePagination: {
    labelRowsPerPage: 'Linhas por página',
    labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} de ${count}`,
  },
} as Partial<GridLocaleText>;

const ListaDeDepositados: React.FC = () => {
  const classes = useGenericStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);
  
  const usuarioid = useSelector((state: RootState) => state.auth.usuario.participante.id);
  const isUsuarioCustodiante = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Custodiante
  );
  const isUsuarioCoordenador = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Coordenador
  );
  const isUsuarioEmissor = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Emissor
  );
  const isUsuarioAgenteFiduciario = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.AgenteFiduciario
  );
  const isUsuarioAdministradorFiduciario = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.AdministradorFiduciario
  );
  const isUsuarioEscriturador = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Escriturador
  );

  const isUsuarioCadastroOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.CadastroOperacoes;
  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const isParticipanteEmissor =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Emissor;
  const isParticipanteCredenciado =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Credenciado;
  const isParticipanteCustodiante = useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Custodiante;
  const isUsuarioOperacoesMaster = useSelector(
    (state: RootState) => state.auth.usuario.participante.perfil === Perfil.Master
  );
  const postInstrumentosPaginated = useSelector((state: RootState) => state.instrumentoApi.postInstrumentosPaginated);
  const postLiberarInstrumento = useSelector((state: RootState) => state.instrumentoApi.postLiberarInstrumento);
  const postSuspenderInstrumento = useSelector((state: RootState) => state.instrumentoApi.postSuspenderInstrumento);
  const postEnviarLiquidacao = useSelector((state: RootState) => state.instrumentoApi.postEnviarLiquidacao);
  const deleteInstrumento = useSelector((state: RootState) => state.instrumentoApi.deleteInstrumento);
  const postGerarRascunho = useSelector((state: RootState) => state.instrumentoApi.postGerarRascunho);
  const postRelatorioCompletoDownload = useSelector(
    (state: RootState) => state.instrumentoApi.postRelatorioCompletoDownload
  );
  const getCraByInstrumentoId = useSelector((state: RootState) => state.craApi.getCraByInstrumentoId);
  const getCdcaByInstrumentoId = useSelector((state: RootState) => state.cdcaApi.getCdcaByInstrumentoId);
  const getCotasDeFundoByInstrumentoId = useSelector(
    (state: RootState) => state.cotasDeFundoApi.getCotasDeFundoByInstrumentoId
  );
  const getCriByInstrumentoId = useSelector((state: RootState) => state.criApi.getCriByInstrumentoId);
  const getDebentureByInstrumentoId = useSelector((state: RootState) => state.debentureApi.getDebentureByInstrumentoId);
  const getNotaComercialByInstrumentoId = useSelector(
    (state: RootState) => state.notaComercialApi.getNotaComercialByInstrumentoId
  );
  const getCertificadoRecebiveisByInstrumentoId = useSelector(
    (state: RootState) => state.certificadoRecebiveisApi.getCertificadoRecebiveisByInstrumentoId
  );

  const [instrumentosFinanceirosFilter, setInstrumentosFinanceirosFilter] = useState<
    Array<InstrumentosFinanceirosFilter>
  >([]);
  const [linkOperator, setLinkOperator] = useState<any>('AND');

  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(1);
  const [instrumentoList, setInstrumentoList] = useState<Array<InstrumentoFinanceiroApiResponse>>([]);
  const [emissaoStatusFilter, setEmissaoStatusFilter] = useState<Array<EmissaoStatus>>([]);
  const [tipoInstrumentoFilter, setTipoInstrumentoFilter] = useState<Array<InstrumentoFinanceiro>>([]);
  const [codigoFilter, setCodigoFilter] = useState<string>('');
  const [inadimplenteFilter, setInadimplenteFilter] = useState<boolean>(false);
  const [encerradoFilter, setEncerradoFilter] = useState<boolean>(false);
  const [aditivoFilter, setAditivoFilter] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(20);

  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [drawerAction, setDrawerAction] = useState<DrawerAction>(DrawerAction.Suspender);
  const [openSolicitarLiquidacaoDrawer, setOpenSolicitarLiquidacaoDrawer] = useState(false);
  const [precoUnitarioLiquidacao, setPrecoUnitarioLiquidacao] = useState<number>(0);
  const [selectedInstrumento, setSelectedInstrumento] = useState<InstrumentoFinanceiroApiResponse>();
  const [codigoLiquidacaoSolicitado, setCodigoLiquidacaoSolicitado] = useState<string>();
  const [codigoLiquidado, setCodigoLiquidado] = useState<string>();
  const [codigoExcluido, setCodigoExcluido] = useState<string>();
  const [instrumentoId, setInstrumentoId] = useState<string>();

  const [openExcluirInstrumentoDrawer, setOpenExcluirInstumentoDrawer] = useState<boolean>(false);
  const [justificativa, setJustificativa] = useState<string>('');

  const [tipoLiquidacao, setTipoLiquidacao] = useState<TipoLiquidacao>(TipoLiquidacao.Direta);

  const exclusions = ['OUTRAS', 'FS'];
  const tipoLiquidacaoList = Object.keys(tipoLiquidacaoDescriptions).filter((item) => !exclusions.includes(item));
  const postUploadBloqueio = useSelector((state: RootState) => state.instrumentoApi.postUploadCertidaoAtivos);

  const getInstrumentoList = useCallback(async () => {
    try {
      const result = await postInstrumentosPaginated(
        dispatch,
        {
          registroStatus: [RegistroStatus.Aprovado, RegistroStatus.AguardandoAprovacaoEdicao, RegistroStatus.AguardandoAprovacaoAditamento],
          page: page + 1,
          pageSize: pageSize,
          emissaoStatus: emissaoStatusFilter,
          codigo: codigoFilter.toUpperCase() ?? undefined,
          inadimplente: inadimplenteFilter ? inadimplenteFilter : undefined,
          aditado: aditivoFilter ? aditivoFilter : undefined,
          encerrado: encerradoFilter ? encerradoFilter : undefined,
          tipoInstrumento: tipoInstrumentoFilter,
          instrumentosFinanceirosFilter: instrumentosFinanceirosFilter,
        },
        true,
        isUsuarioEmissor ? usuarioid : null,
        isUsuarioCustodiante ? usuarioid : null,
        isUsuarioCoordenador ? usuarioid : null,
        isUsuarioAgenteFiduciario ? usuarioid : null,
        null, // escrituradorId
        isUsuarioAdministradorFiduciario ? usuarioid : null,
      );

      setInstrumentoList(result.result);
      setPageCount(result.totalCount);
    } catch (error) { }
  }, [
    dispatch,
    postInstrumentosPaginated,
    page,
    pageSize,
    emissaoStatusFilter,
    codigoFilter,
    aditivoFilter,
    encerradoFilter,
    inadimplenteFilter,
    tipoInstrumentoFilter,
    instrumentosFinanceirosFilter,
    isUsuarioEmissor,
    isUsuarioCustodiante,
    isUsuarioCoordenador,
    isUsuarioAgenteFiduciario,
    isUsuarioAdministradorFiduciario,
    usuarioid,
  ]);

  const handleOpenDrawer = (id: string, action: DrawerAction) => {
    setInstrumentoId(id);
    setDrawerAction(action);
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setInstrumentoId(undefined);
    setOpenDrawer(false);
  };

  const submitSuspender = useCallback(
    async (justificativa: string, anexos: Array<Attachment>) => {
      try {
        const files = anexos.map((anexo) => anexo.file!);
        await postSuspenderInstrumento(dispatch, instrumentoId!, justificativa, files, true);
        await getInstrumentoList();
      } catch (error) { }
    },
    [dispatch, postSuspenderInstrumento, getInstrumentoList, instrumentoId]
  );

  const submitLiberar = useCallback(
    async (justificativa: string, anexos: Array<Attachment>) => {
      try {
        const files = anexos.map((anexo) => anexo.file!);
        await postLiberarInstrumento(dispatch, instrumentoId!, justificativa, files, true);
        await getInstrumentoList();
      } catch (error) {}
    },
    [dispatch, postLiberarInstrumento, getInstrumentoList, instrumentoId]
  );

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleConfirmarLiquidacao = async (instrumento: InstrumentoFinanceiroApiResponse) => {
    switch (instrumento.tipoInstrumentoFinanceiro) {
      case InstrumentoFinanceiro.Cdca:
        const cdca = await getCdcaByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/cdcas/${cdca.cdcaId}`, { initialTab: 6 });
        break;
      case InstrumentoFinanceiro.CotasDeFundo:
        const cotasDeFundo = await getCotasDeFundoByInstrumentoId(
          dispatch,
          instrumento.instrumentoFinanceiroGuid,
          true
        );
        history.push(`/instrumentos/gerenciar/cotas-de-fundos/${cotasDeFundo.cotasDeFundoId}`, { initialTab: 6 });
        break;
      case InstrumentoFinanceiro.Cra:
        const cra = await getCraByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/cras/${cra.craId}`, { initialTab: 6 });
        break;
      case InstrumentoFinanceiro.Cri:
        const cri = await getCriByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/cris/${cri.criId}`, { initialTab: 6 });
        break;
      case InstrumentoFinanceiro.Debenture:
        const debenture = await getDebentureByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/debentures/${debenture.debentureId}`, { initialTab: 6 });
        break;
      case InstrumentoFinanceiro.NotaComercial:
        const nc = await getNotaComercialByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/notas-comerciais/${nc.notaComercialId}`, { initialTab: 6 });
        break;
      case InstrumentoFinanceiro.CertificadoRecebiveis:
        const cr = await getCertificadoRecebiveisByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/certificados-recebiveis/${cr.certificadoRecebiveisId}`, {
          initialTab: 6,
        });
        break;
      default:
        break;
    }
  };

  const handleVerDetalhes = async (instrumento: InstrumentoFinanceiroApiResponse) => {
    switch (instrumento.tipoInstrumentoFinanceiro) {
      case InstrumentoFinanceiro.Cdca:
        const cdca = await getCdcaByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/cdcas/${cdca.cdcaId}`);
        break;
      case InstrumentoFinanceiro.CotasDeFundo:
        const cotasDeFundo = await getCotasDeFundoByInstrumentoId(
          dispatch,
          instrumento.instrumentoFinanceiroGuid,
          true
        );
        history.push(`/instrumentos/gerenciar/cotas-de-fundos/${cotasDeFundo.cotasDeFundoId}`, { detalhes: cotasDeFundo });
        break;
      case InstrumentoFinanceiro.Cra:
        const cra = await getCraByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/cras/${cra.craId}`);
        break;
      case InstrumentoFinanceiro.Cri:
        const cri = await getCriByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/cris/${cri.criId}`);
        break;
      case InstrumentoFinanceiro.Debenture:
        const debenture = await getDebentureByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/debentures/${debenture.debentureId}`);
        break;
      case InstrumentoFinanceiro.NotaComercial:
        const nc = await getNotaComercialByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/notas-comerciais/${nc.notaComercialId}`);
        break;
      case InstrumentoFinanceiro.CertificadoRecebiveis:
        const cr = await getCertificadoRecebiveisByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        history.push(`/instrumentos/gerenciar/certificados-recebiveis/${cr.certificadoRecebiveisId}`);
        break;
      default:
        break;
    }
  };

  const getInstrumentoDataForDivergencias = useCallback((instrumento: InstrumentoFinanceiroApiResponse) => ({
    id: instrumento.id,
    codigo: instrumento.codigo,
    tipoInstrumentoFinanceiro: instrumento.tipoInstrumentoFinanceiro,
    origem: instrumento.origem,
    statusValidacao: instrumento.statusValidacao,
    dataDeCriacao: instrumento.dataDeCriacao
  }), []);

  const handleEditar = async (instrumento: InstrumentoFinanceiroApiResponse) => {
    const routeMap = {
      [InstrumentoFinanceiro.Debenture]: async () => {
        const debenture = await getDebentureByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return {
          route: `/instrumentos/gerenciar/debenture/${debenture.debentureId}`,
          state: {
            acao: TipoRegistroInstrumentoFinanceiro.EdicaoEmitido,
            instrumentoData: getInstrumentoDataForDivergencias(instrumento)
          }
        };
      },
      [InstrumentoFinanceiro.NotaComercial]: async () => {
        const nc = await getNotaComercialByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return {
          route: `/instrumentos/gerenciar/nota-comercial/${nc.notaComercialId}`,
          state: {
            acao: TipoRegistroInstrumentoFinanceiro.EdicaoEmitido,
            instrumentoData: getInstrumentoDataForDivergencias(instrumento)
          }
        };
      },
      [InstrumentoFinanceiro.Cdca]: async () => {
        const cdca = await getCdcaByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return {
          route: `/instrumentos/gerenciar/cdca/${cdca.cdcaId}`,
          state: { acao: TipoRegistroInstrumentoFinanceiro.EdicaoEmitido }
        };
      },
      [InstrumentoFinanceiro.CotasDeFundo]: async () => {
        const cotasDeFundo = await getCotasDeFundoByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return {
          route: `/instrumentos/gerenciar/cotas-de-fundo/${cotasDeFundo.cotasDeFundoId}`,
          state: { acao: TipoRegistroInstrumentoFinanceiro.EdicaoEmitido }
        };
      },
      [InstrumentoFinanceiro.Cra]: async () => {
        const cra = await getCraByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return {
          route: `/instrumentos/gerenciar/cra/${cra.craId}`,
          state: { acao: TipoRegistroInstrumentoFinanceiro.EdicaoEmitido }
        };
      },
      [InstrumentoFinanceiro.Cri]: async () => {
        const cri = await getCriByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return {
          route: `/instrumentos/gerenciar/cri/${cri.criId}`,
          state: { acao: TipoRegistroInstrumentoFinanceiro.EdicaoEmitido }
        };
      },
      [InstrumentoFinanceiro.CertificadoRecebiveis]: async () => {
        const cr = await getCertificadoRecebiveisByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return {
          route: `/instrumentos/gerenciar/certificado-recebiveis/${cr.certificadoRecebiveisId}`,
          state: { acao: TipoRegistroInstrumentoFinanceiro.EdicaoEmitido }
        };
      }
    };

    const routeHandler = routeMap[instrumento.tipoInstrumentoFinanceiro];
    if (routeHandler) {
      try {
        const { route, state } = await routeHandler();
        history.push(route, state);
      } catch (error) {
        console.error('Erro ao navegar para edição:', error);
        dispatch(addAlert({
          severity: 'error',
          message: 'Erro ao abrir formulário de edição. Tente novamente.'
        }));
      }
    }
  };

  const handleAditar = async (instrumento: InstrumentoFinanceiroApiResponse) => {
    switch (instrumento.tipoInstrumentoFinanceiro) {
      case InstrumentoFinanceiro.Cdca:
        const cdca = await getCdcaByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return history.push(`/instrumentos/gerenciar/cdca/${cdca.cdcaId}`, {
          acao: TipoRegistroInstrumentoFinanceiro.Aditamento,
        });
      case InstrumentoFinanceiro.CotasDeFundo:
        const cotasDeFundo = await getCotasDeFundoByInstrumentoId(
          dispatch,
          instrumento.instrumentoFinanceiroGuid,
          true
        );
        return history.push(`/instrumentos/gerenciar/cotas-de-fundo/${cotasDeFundo.cotasDeFundoId}`, {
          acao: TipoRegistroInstrumentoFinanceiro.Aditamento,
        });
      case InstrumentoFinanceiro.Cra:
        const cra = await getCraByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return history.push(`/instrumentos/gerenciar/cra/${cra.craId}`, {
          acao: TipoRegistroInstrumentoFinanceiro.Aditamento,
        });
      case InstrumentoFinanceiro.Cri:
        const cri = await getCriByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return history.push(`/instrumentos/gerenciar/cri/${cri.criId}`, {
          acao: TipoRegistroInstrumentoFinanceiro.Aditamento,
        });
      case InstrumentoFinanceiro.Debenture:
        const debenture = await getDebentureByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return history.push(`/instrumentos/gerenciar/debenture/${debenture.debentureId}`, {
          acao: TipoRegistroInstrumentoFinanceiro.Aditamento,
        });
      case InstrumentoFinanceiro.NotaComercial:
        const nc = await getNotaComercialByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return history.push(`/instrumentos/gerenciar/nota-comercial/${nc.notaComercialId}`, {
          acao: TipoRegistroInstrumentoFinanceiro.Aditamento,
        });
      case InstrumentoFinanceiro.CertificadoRecebiveis:
        const cr = await getCertificadoRecebiveisByInstrumentoId(dispatch, instrumento.instrumentoFinanceiroGuid, true);
        return history.push(`/instrumentos/gerenciar/certificado-recebiveis/${cr.certificadoRecebiveisId}`, {
          acao: TipoRegistroInstrumentoFinanceiro.Aditamento,
        });
    }
  };

  const handleExcluir = async () => {
    try {
      if (!justificativa) {
        dispatch(addAlert({ severity: 'error', message: 'O campo de Justificativa é obrigatório.' }));
        return;
      }
      if (selectedInstrumento) {
        await deleteInstrumento(dispatch, selectedInstrumento.instrumentoFinanceiroGuid!, justificativa, true);
        setCodigoExcluido(selectedInstrumento.codigo ?? '');
        handleCloseExcluirInstrumentoDrawer();
        getInstrumentoList();
      }
    } catch (error) {}
  };

  const handleGerarRascunho = async (instrumentoFinanceiroId: string) => {
    try {
      const result = await postGerarRascunho(dispatch, instrumentoFinanceiroId, true);
      dispatch(addAlert({ severity: 'success', message: result }));
    } catch (error) {}
  };

  const handleExportar = async () => {
    try {
      const obj = {
        registroStatus: [RegistroStatus.Aprovado],
        page: page + 1,
        pageSize: undefined,
        emissaoStatus: emissaoStatusFilter,
        codigo: codigoFilter.toUpperCase() ?? undefined,
        inadimplente: inadimplenteFilter ? inadimplenteFilter : undefined,
        aditado: aditivoFilter ? aditivoFilter : undefined,
        encerrado: encerradoFilter ? encerradoFilter : undefined,
        tipoInstrumento: tipoInstrumentoFilter,
        instrumentosFinanceirosFilter: instrumentosFinanceirosFilter,
      } as GETInstrumentosFilterParams;
      const timeoutMs = 300000;
      const result = await postRelatorioCompletoDownload(
        dispatch,
        obj,
        true,
        timeoutMs
      );
      const blob = new Blob([result], { type: 'blob' });
      const link = document.createElement('a');
      const href = window.URL.createObjectURL(blob);
      link.href = href;
      link.download = `instrumentos-financeiros.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(href);
    } catch (error) { }
  };

  const handleOpenExcluirInstumentoDrawer = (instrumento: InstrumentoFinanceiroApiResponse) => {
    setSelectedInstrumento(instrumento);
    setOpenExcluirInstumentoDrawer(true);
  };

  const handleCloseExcluirInstrumentoDrawer = () => {
    setSelectedInstrumento(undefined);
    setJustificativa('');
    setOpenExcluirInstumentoDrawer(false);
  };

  const handleSolicitarLiquidacao = async () => {
    try {
      if (selectedInstrumento) {
        const request: SolicitarLiquidacaoRequest = {
          precoUnitario: precoUnitarioLiquidacao,
          tipoLiquidacao: tipoLiquidacao,
        };
        await postEnviarLiquidacao(dispatch, selectedInstrumento.instrumentoFinanceiroGuid!, request, true);
        setCodigoLiquidacaoSolicitado(selectedInstrumento?.codigo ?? '');
        handleCloseSolicitarLiquidacaoDrawer();
        getInstrumentoList();
      }
    } catch (error) { }
  };

  const handleOpenSolicitarLiquidacaoDrawer = (response: InstrumentoFinanceiroApiResponse) => {
    setSelectedInstrumento(response);
    setOpenSolicitarLiquidacaoDrawer(true);
  };

  async function handleDownload(instrumento: string) {
    await postUploadBloqueio(dispatch, instrumento, true);
  }

  const handleCloseSolicitarLiquidacaoDrawer = () => {
    setSelectedInstrumento(undefined);
    setOpenSolicitarLiquidacaoDrawer(false);
  };

  useEffect(() => {
    getInstrumentoList();
  }, [getInstrumentoList]);

  useEffect(() => {
    setPrecoUnitarioLiquidacao(0);
    setTipoLiquidacao(TipoLiquidacao.Direta);
  }, [openSolicitarLiquidacaoDrawer, setPrecoUnitarioLiquidacao, setTipoLiquidacao]);

  const SolicitarLiquidacaoDrawer = (
    <GenericDrawer
      opened={openSolicitarLiquidacaoDrawer}
      onClose={handleCloseSolicitarLiquidacaoDrawer}
      title={`Solicitar Liquidação`}
      buttons={[
        {
          buttonText: `Solicitar Liquidação`,
          buttonAction: handleSolicitarLiquidacao,
          buttonColor: 'primary',
          buttonDisable: precoUnitarioLiquidacao <= 0,
        },
        {
          buttonText: 'Cancelar',
          buttonAction: handleCloseSolicitarLiquidacaoDrawer,
        },
      ]}
    >
      <NumberField
        label={'PU de Liquidação'}
        value={precoUnitarioLiquidacao}
        required
        onChange={(value) => setPrecoUnitarioLiquidacao(value ?? 0)}
        numberType="eightDecimals"
      />
      <SmSpace />
      <Dropdown
        label={labelsCaracteristicas.tipoLiquidacao}
        required
        options={tipoLiquidacaoList.map((item: string) => ({
          value: item,
          description: tipoLiquidacaoDescriptions[item],
        }))}
        value={tipoLiquidacao}
        onChange={(value) => setTipoLiquidacao(value as TipoLiquidacao)}
      />
      <SmSpace />
    </GenericDrawer>
  );

  const ExcluirInstrumentoDrawer = (
    <GenericDrawer
      opened={openExcluirInstrumentoDrawer}
      onClose={handleCloseSolicitarLiquidacaoDrawer}
      title={`Exclusão de Instrumento`}
      buttons={[
        {
          buttonText: `Excluir Instrumento`,
          buttonAction: handleExcluir,
          buttonColor: 'error',
        },
        {
          buttonText: 'Cancelar',
          buttonAction: handleCloseExcluirInstrumentoDrawer,
        },
      ]}
    >
      <Typography>{`Tem certeza que deseja excluir o instrumento ${selectedInstrumento?.codigo ?? ''}?`}</Typography>
      <MdSpace />
      <TextField
        label="Justificativa *"
        value={justificativa}
        rows={5}
        onChange={(value) => setJustificativa(value)}
        multiline
        fullWidth
      />
      <MdSpace />
    </GenericDrawer>
  );

  const getStatusIcon = (status: EmissaoStatus) => {
    switch (status) {
      case EmissaoStatus.AguardandoLiquidacao:
        return <Error fontSize="small" className={classes.warningIcon} />;
      case EmissaoStatus.Emitido:
        return <CheckCircle fontSize="small" className={classes.successIcon} />;
      case EmissaoStatus.ParcialmenteEmitido:
        return <CheckCircle fontSize="small" className={classes.waitingIcon} />;
      case EmissaoStatus.NaoEmitido:
        return <CheckCircle fontSize="small" className={classes.buttonIcon} style={{ marginLeft: '10px' }} />;
      default:
        return <></>;
    }
  };

  const getCustodiantes = (custodiantes: Array<Custodiante> | undefined) => {
    var custodianteNames: string = '';
    if (custodiantes) {
      for (let custodiante of custodiantes) {
        custodianteNames += `${custodiante.razaoSocialInstituicaoCustodiante} \n`;
      }
    }
    return custodianteNames;
  };

  const onFilterChange = useCallback(
    (filterModel: GridFilterModel) => {
      if (!filterModel.items) {
        setInstrumentosFinanceirosFilter([]);
        return;
      }
      setLinkOperator(filterModel?.linkOperator?.toString()?.toUpperCase() ?? 'AND');
      var instrumentosFinanceirosFilter = new Array<InstrumentosFinanceirosFilter>();

      filterModel.items.forEach((filter) => {
        let operatorValue =
          filter.operatorValue == 'startsWith'
            ? 'STARTS_WITH'
            : filter.operatorValue == 'endsWith'
            ? 'ENDS_WITH'
            : filter.operatorValue?.toUpperCase();

        let formattedValue = filter.value?.toString();
        if (formattedValue) {
          if (filter.columnField == 'TIPO_INSTRUMENTO_FINANCEIRO') {
            formattedValue = formattedValue.replace('_', ' ');
          }
          if (filter.columnField.startsWith('DATA')) {
            formattedValue = formattedValue.split('-');
            formattedValue = `${formattedValue[2]}/${formattedValue[1]}/${formattedValue[0]}`;
          }

          let params = {
            columnType: filter.columnField.toUpperCase(),
            operationFilterType: operatorValue,
            value: formattedValue,
          } as InstrumentosFinanceirosFilter;

          instrumentosFinanceirosFilter.push(params);
        }

      });

      setInstrumentosFinanceirosFilter(instrumentosFinanceirosFilter);
    },
    [postInstrumentosPaginated, page, pageSize, linkOperator, instrumentosFinanceirosFilter]
  );

  const onSortChange = useCallback(
    (filterModel: GridSortModel) => {
      if (filterModel == null) return;

      var filter = filterModel[0];
      let params = {
        columnType: filter.field.toUpperCase(),
        orderByType: filter.sort?.toUpperCase(),
      } as InstrumentosFinanceirosFilter;

      var newEFFilter = instrumentosFinanceirosFilter.filter(
        (x) => x.orderByType != 'ASC' && x.orderByType != 'DESC'
      ) as Array<InstrumentosFinanceirosFilter>;
      newEFFilter.push(params);
      setInstrumentosFinanceirosFilter([...newEFFilter]);
    },
    [postInstrumentosPaginated, page, pageSize, instrumentosFinanceirosFilter]
  );

  const filterOperators = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains', 'startsWith', 'endsWith'].includes(value)
  );

  const filterOperatorsSelect = getGridSingleSelectOperators().filter(({ value }) => ['is', 'not'].includes(value));

  const filterOperatorsData = getGridDateOperators();

  const getSituacao = (instFin: InstrumentoFinanceiroApiResponse) => {
    var situacao = '';
    if (instFin.encerrado) {
      situacao += 'ENCERRADO ';
    }
    if (instFin.aditado) {
      situacao += 'ADITADO ';
    }
    if (instFin.suspenso) {
      situacao += 'SUSPENSO ';
    }
    if (instFin.hasPagamentosInadimplentes) {
      situacao += 'INADIMPLENTE';
    }
    return situacao;
  };

  const getGridColumns = useCallback(
    (): GridColDef[] => [
      {
        field: 'Codigo',
        headerName: 'Codigo',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 180,
        minWidth: 100,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => (params.row as InstrumentoFinanceiroApiResponse).codigo,
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          const processoEmAndamento = possuiProcessoEmAndamento(instrumento.registro.status);
          return (
            <>
              <div style={{ display: 'flex', alignItems: 'center', width: '114px', padding: '0px 10px 0px 16px' }}>
                <Typography variant="subtitle1">{instrumento.codigo ?? instrumento.ticket}</Typography>
              </div>
              {(isUsuarioOperacoes ||
                isUsuarioCadastroOperacoes ||
                isParticipanteEmissor ||
                isParticipanteCredenciado ||
                isParticipanteCustodiante ||
                isUsuarioAgenteFiduciario ||
                isUsuarioEscriturador) &&
                !isUsuarioLeitura && (
                  <MoreOptionsMenu
                    disabled={instrumento.tipoInstrumentoFinanceiro === InstrumentoFinanceiro.CotasDeFundo as any}>
                    {(
                      (isUsuarioCadastroOperacoes &&
                        (instrumento.statusEmissao === EmissaoStatus.Emitido ||
                          instrumento.statusEmissao === EmissaoStatus.ParcialmenteEmitido))
                      ||
                      ((isUsuarioAgenteFiduciario || isUsuarioEscriturador) &&
                        instrumento.distribuicaoPublica === true &&
                        (instrumento.statusEmissao === EmissaoStatus.Emitido ||
                          instrumento.statusEmissao === EmissaoStatus.ParcialmenteEmitido))
                    ) &&
                      !instrumento.encerrado && (
                        <Tooltip 
                          title={processoEmAndamento ? "Ação indisponível. Há um processo em andamento que precisa ser finalizado." : ""} 
                          disableHoverListener={!processoEmAndamento}>
                            <div>
                              <MenuItem
                                onClick={() => handleAditar(instrumento)}
                                disabled={processoEmAndamento}
                              >
                                <Edit fontSize="small" style={{ marginRight: '10px' }} />
                                {'Aditar'}
                                {processoEmAndamento && (
                                  <Error fontSize="small" className={classes.warningIcon} style={{ marginLeft: '10px' }} />
                                )}
                              </MenuItem>
                            </div>
                        </Tooltip>
                      )}
                    {podeExibirEditar({ isUsuarioOperacoes, isUsuarioCadastroOperacoes }, instrumento) && (
                        <Tooltip 
                          title={processoEmAndamento ? "Ação indisponível. Há um processo em andamento que precisa ser finalizado." : ""} 
                          disableHoverListener={!processoEmAndamento}>
                            <div>
                              <MenuItem
                                disabled={processoEmAndamento}
                                onClick={() => handleEditar(instrumento)}
                              >
                                <Edit fontSize="small" style={{ marginRight: '10px' }} />
                                {'Editar'}
                                {processoEmAndamento && (
                                  <Error fontSize="small" className={classes.warningIcon} style={{ marginLeft: '10px' }} />
                                )}
                              </MenuItem>
                            </div>
                        </Tooltip>
                      )}
                    {((isUsuarioOperacoes && !isUsuarioOperacoesMaster) || isUsuarioCadastroOperacoes) && (
                      <MenuItem onClick={() => handleGerarRascunho(instrumento.instrumentoFinanceiroGuid)}>
                        <Brush fontSize="small" style={{ marginRight: '10px' }} />
                        {'Copiar como Rascunho'}
                      </MenuItem>
                    )}
                    {isUsuarioOperacoes && (
                      <MenuItem onClick={() => handleOpenExcluirInstumentoDrawer(instrumento)}>
                        <Delete fontSize="small" style={{ marginRight: '10px' }} />
                        {'Excluir'}
                      </MenuItem>
                    )}
                    {isUsuarioOperacoes && (
                          <>
                            {instrumento.suspenso && (
                              <MenuItem
                                onClick={() =>
                                  handleOpenDrawer(instrumento.instrumentoFinanceiroGuid, DrawerAction.Liberar)
                                }
                              >
                                <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                                {'Liberar'}
                              </MenuItem>
                            )}
                            {!instrumento.suspenso && instrumento.statusEmissao === EmissaoStatus.NaoEmitido && (
                              <MenuItem
                                onClick={() =>
                                  handleOpenDrawer(instrumento.instrumentoFinanceiroGuid, DrawerAction.Suspender)
                                }
                              >
                                <HighlightOff fontSize="small" style={{ marginRight: '10px' }} />
                                {'Suspender'}
                              </MenuItem>
                            )}
                            {(instrumento.statusEmissao === EmissaoStatus.NaoEmitido ||
                              instrumento.statusEmissao === EmissaoStatus.ParcialmenteEmitido) &&
                              instrumento.canSolicitarLiquidacao && (
                                <MenuItem onClick={() => handleOpenSolicitarLiquidacaoDrawer(instrumento)}>
                                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                                  {'Liquidar'}
                                </MenuItem>
                              )}
                            {instrumento.statusEmissao === EmissaoStatus.AguardandoLiquidacao &&
                              instrumento.criteriosRemuneracao?.liquidacaoDireta && (
                                <MenuItem onClick={() => handleConfirmarLiquidacao(instrumento)}>
                                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                                  {'Confirmar Liquidação'}
                                </MenuItem>
                              )}
                          </>
                        )}
                  </MoreOptionsMenu>
                )}
            </>
          );
        },
      },
      {
        field: 'STATUS_EMISSAO',
        headerName: 'Status',
        type: 'singleSelect',
        valueOptions: ['Emitido', 'Aguardando Liquidação', 'Não Emitido', 'Parcialmente Emitido'],
        filterOperators: filterOperatorsSelect,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 65,
        minWidth: 65,
        maxWidth: 130,
        valueGetter: (params: GridValueGetterParams) =>
          obterStatusExibido(params.row as InstrumentoFinanceiroApiResponse),
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return possuiProcessoEmAndamento(instrumento.registro.status) ? (
            <>
              <Tooltip title={registroStatusDescriptions[instrumento.registro.status]} aria-label={registroStatusDescriptions[instrumento.registro.status]}>
                  <Error fontSize="small" className={classes.warningIcon} />
              </Tooltip>
            </>
          ) : (
            <>
              <Tooltip
                title={emissaoStatusDescriptions[instrumento.statusEmissao]}
                aria-label={emissaoStatusDescriptions[instrumento.statusEmissao]}
              >
                {getStatusIcon(instrumento.statusEmissao)}
              </Tooltip>
            </>
          );
        },
      },
      {
        field: 'TIPO_INSTRUMENTO_FINANCEIRO',
        headerName: 'Tipo',
        type: "singleSelect",
        valueOptions: ["CDCA", "Cotas de Fundo", "CRA", "CRI", "Certificado de Recebíveis", "Debênture", "Nota Comercial"],
        filterable: true,
        filterOperators: filterOperatorsSelect,
        sortable: true,
        disableExport: false,
        width: 160,
        minWidth: 100,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => (params.row as InstrumentoFinanceiroApiResponse).tipoInstrumentoFinanceiro,
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return (
            <div style={{ fontSize: '11px' }}>
              {instrumento.tipoInstrumentoFinanceiro}
            </div>
          );
        },
      },
      {
        field: 'Situacao',
        headerName: 'Situação',
        type: "singleSelect",
        valueOptions: ["ENCERRADO", "ADITADO", "INADIMPLENTE"],
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 100,
        minWidth: 100,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => getSituacao((params.row as InstrumentoFinanceiroApiResponse)),
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return (
            <>
              {instrumento.encerrado &&
                (<Chip style={{ fontSize: '9px' }} size="small" label="ENCERRADO" color="success" />)
              }
              {instrumento.aditado &&
                (<Chip style={{ marginLeft: 5, fontSize: '9px' }} size="small" label="ADITADO" />)
              }
              {instrumento.suspenso &&
                (<Chip style={{ marginLeft: 5, fontSize: '9px' }} size="small" label="SUSPENSO" color="error" />)
              }
              {instrumento.hasPagamentosInadimplentes &&
                (<Chip style={{ marginLeft: 5, fontSize: '9px' }} size="small" label="INADIMPLENTE" color="error" />)
              }
            </>
          );
        },
      },
      {
        field: 'RAZAO_EMISSOR',
        headerName: 'Emissor',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 200,
        minWidth: 100,
        maxWidth: 250,
        valueGetter: (params: GridValueGetterParams) => (params.row as InstrumentoFinanceiroApiResponse).razaoSocialEmissor,
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return (
            <>
              {instrumento.razaoSocialEmissor ?? ''}
            </>
          );
        },
      },
      {
        field: 'NUMERO_EMISSAO',
        headerName: 'Numero Emissão',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 150,
        minWidth: 100,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => (params.row as InstrumentoFinanceiroApiResponse).numeroEmissao,
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return (
            <>
              <Typography variant="body2" className={classes.wrapTxt}>
                {`Emissão ${instrumento.numeroEmissao}`}
              </Typography>
            </>
          );
        },
      },
      {
        field: 'NUMERO_SERIE',
        headerName: 'Numero Série',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 150,
        minWidth: 100,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => (params.row as InstrumentoFinanceiroApiResponse).numeroSerie,
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return (
            <>
              <Typography variant="body2" className={classes.wrapTxt}>
                {`Série ${instrumento.numeroSerie}`}
              </Typography>
            </>
          );
        },
      },
      {
        field: 'RAZAO_SOCIAL_CUSTODIANTE',
        headerName: 'Custodiante',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 150,
        minWidth: 100,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => getCustodiantes((params.row as InstrumentoFinanceiroApiResponse).custodiantes),
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {instrumento.custodiantes?.map((custodiante) => (
                <div>
                  {custodiante.razaoSocialInstituicaoCustodiante}
                </div>

              ))}
            </div>
          );
        },
      },
      {
        field: 'RAZAO_SOCIAL_ESCRITURADOR',
        headerName: 'Escriturador',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 150,
        minWidth: 100,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => (params.row as InstrumentoFinanceiroApiResponse).razaoSocialEscriturador,
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return (
            <>
              {instrumento.razaoSocialEscriturador}

            </>
          );
        },
      },
      {
        field: 'PU_DIARIO',
        headerName: 'PU Atualizada',
        type: 'number',
        filterable: false,
        sortable: false,
        disableExport: false,
        width: 150,
        minWidth: 100,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => (params.row as InstrumentoFinanceiroApiResponse).puDiario,
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return (
            <>
              {instrumento.puDiario != null
                ? formatEightDecimalsNumber(instrumento.puDiario)
                : ''}
            </>
          );
        },
      },
      {
        field: 'DATA_EMISSAO',
        headerName: 'Data da Emissão',
        type: 'date',
        filterOperators: filterOperatorsData,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 100,
        minWidth: 100,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => {
          const row = params.row as InstrumentoFinanceiroApiResponse;
          return row.criteriosRemuneracao?.dataEmissao ?? '-';
        },
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return (
            <>
              {instrumento.criteriosRemuneracao?.dataEmissao ? formatDate(instrumento.criteriosRemuneracao.dataEmissao) : '-'}
            </>
          );
        },
      },
      {
        field: 'DATA_CRIACAO',
        headerName: 'Data de Criação',
        type: 'date',
        filterOperators: filterOperatorsData,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 100,
        minWidth: 100,
        maxWidth: 150,
        valueGetter: (params: GridValueGetterParams) => (params.row as InstrumentoFinanceiroApiResponse).dataDeCriacao,
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return <>{formatDate(instrumento.dataDeCriacao)}</>;
        },
      },
      {
        field: 'DATA_APROVACAO',
        headerName: 'Data de Aprovação',
        type: 'date',
        filterOperators: filterOperatorsData,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 100,
        minWidth: 100,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => (params.row as InstrumentoFinanceiroApiResponse).dataDeAprovacao,
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return <>{formatDate(instrumento.dataDeAprovacao)}</>;
        },
      },
      {
        field: 'Detalhes',
        headerName: '',
        type: 'string',
        filterOperators,
        filterable: false,
        sortable: false,
        disableExport: true,
        width: 100,
        minWidth: 100,
        maxWidth: 150,
        renderCell: (params: GridCellParams) => {
          const instrumento = params.row as InstrumentoFinanceiroApiResponse;
          return (
            <>
              <MoreOptionsMenu>
                <MenuItem onClick={() => handleVerDetalhes(instrumento)}>
                  <Description fontSize="small" style={{ marginRight: '10px' }} />
                  {`Detalhes`}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleDownload(instrumento.codigo);
                  }}
                >
                  <DownloadIcon fontSize="small" style={{ marginRight: '10px' }} />
                  {'Download'}
                </MenuItem>
              </MoreOptionsMenu>
            </>
          );
        },
      },
    ],
    []);

  return (
    <>
      {codigoLiquidacaoSolicitado && (
        <>
          <GenericToast kind={GenericToastKind.Warning} onDismiss={() => setCodigoLiquidacaoSolicitado(undefined)}>
            <Typography variant="body2" display={'inline'}>
              {'Solicitação de liquidação do instrumento financeiro'}
            </Typography>
            &nbsp;<Typography display={'inline'}>{codigoLiquidacaoSolicitado}</Typography>&nbsp;
            <Typography variant="body2" display={'inline'}>
              {'enviada. Pendente de aprovação.'}
            </Typography>
          </GenericToast>
          <MdSpace />
        </>
      )}
      {codigoLiquidado && (
        <>
          <GenericToast kind={GenericToastKind.Success} onDismiss={() => setCodigoLiquidado(undefined)}>
            <Typography variant="body2" display={'inline'}>
              {'Instrumento financeiro'}
            </Typography>
            &nbsp;<Typography display={'inline'}>{codigoLiquidado}</Typography>&nbsp;
            <Typography variant="body2" display={'inline'}>
              {'liquidado com sucesso.'}
            </Typography>
          </GenericToast>
          <MdSpace />
        </>
      )}
      {codigoExcluido && (
        <>
          <GenericToast kind={GenericToastKind.Error} onDismiss={() => setCodigoExcluido(undefined)}>
            <Typography variant="body2" display={'inline'}>
              {'Instrumento financeiro'}
            </Typography>
            &nbsp;<Typography display={'inline'}>{codigoExcluido}</Typography>&nbsp;
            <Typography variant="body2" display={'inline'}>
              {'excluído com sucesso.'}
            </Typography>
          </GenericToast>
          <MdSpace />
        </>
      )}
      <Grid item md={5} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '15px' }}>
        <Grid item>
      {/* <TextButton startIcon={<GetApp color="primary" />} onClick={handleExportar}>
            {'Exportar tabela com todas as informações'}
          </TextButton> */}
        </Grid>
      </Grid>
      <DataGridPro
        autoHeight
        localeText={localizedTextsMap}
        componentsProps={componentsPropsValues}
        rows={instrumentoList}
        columns={getGridColumns()}
        components={{
          Toolbar: CustomToolBarUtils,
        }}
        disableSelectionOnClick
        rowsPerPageOptions={rowsPerPageOptionsValues}
        page={page}
        rowCount={pageCount}
        pagination
        paginationMode="server"
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newPageSize) => {
          setPageSize(newPageSize), setPage(0);
        }}
        pageSize={pageSize}
        filterMode="server"
        onFilterModelChange={onFilterChange}
        sortingMode="server"
        onSortModelChange={onSortChange}
        initialState={{ columns: { columnVisibilityModel: { DATA_CRIACAO: false, DATA_APROVACAO: false } } }}
      />
      <SmSpace />
      {SolicitarLiquidacaoDrawer}
      {ExcluirInstrumentoDrawer}
      <JustificativaAnexoDrawer
        open={openDrawer}
        onClose={handleCloseDrawer}
        onSubmit={drawerAction === DrawerAction.Suspender ? submitSuspender : submitLiberar}
        justificativaObrigatoria
        overrideTitle={
          drawerAction === DrawerAction.Suspender ? 'Justificativa da suspensão' : 'Justificativa da liberação'
        }
        overrideSubmitButtonText={drawerAction === DrawerAction.Suspender ? 'Suspender' : 'Liberar'}
        overrideSubmitButtonColor={drawerAction === DrawerAction.Suspender ? 'error' : undefined}
      />
    </>
  );
};

export default ListaDeDepositados;
